import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Col, Row } from 'antd';
import PictureAssignment from 'components/Image/PictureAssignment';
import TextEditor from 'components/TextEditor';
import AudioRecorder from 'features/AudeoRecorderNew';
import React from 'react';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { imageUpload } from "utils/config/reference";
import { Button, Snackbar, CircularProgress, InputLabel, Select, MenuItem } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';


const StyledFormControl = muiStyled(FormControl)(({ theme }) => ({
  minWidth: 120,
  width: '100%',
  margin: '10px 0',
}));

const StyledInputLabel = muiStyled(InputLabel)({
backgroundColor: 'white',
paddingRight: 5,
});


const  PictureAssignmentType = (props) => {
  const { showResponsePreview=true } = props || {};
  const { question, index } = props?.states;
  const { onChangeQuestionData } = props?.funcObj;
  return (
    <div className="category-type-radio-type">
      {(question.categoryType === 'Image' || question.categoryType === 'ImageAndText') && <StyledFormControl>
            <StyledInputLabel id="type">
              Student can upload up to {question.studentCanUploadImages || 6} images.
            </StyledInputLabel>
            <Select
              labelId="type"
              id="type"
              value={question.studentCanUploadImages || 6}
              required
              onChange={(v) => {
                onChangeQuestionData(v.target.value, 'studentCanUploadImages', index);
              }}
              label="Select Collage Count"
            >
              {imageUpload?.map((v) => (
                <MenuItem key={v.value} value={v.value}>
                  {v.value}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
}
       { showResponsePreview && <div className='setupQuesInfo'>
          <InfoOutlineIcon /> <label>Text below will display the student answer...</label>
        </div>}
      <Detail>Answer Type</Detail>
      <FormControl>
        {/*  */}
        <RadioGroup
          row
          onChange={(e) => onChangeQuestionData(e.target.value, 'categoryType', index)}
          aria-labelledby="category-type-radio-buttons-group-label"
          name="category-type-radio-buttons-group-label"
          style={{ gap: '20px' }}
          defaultValue={'Image'}
          value={question.categoryType}
        >
          <FormControlLabel
            value="Image"
            control={<Radio />}
            label="Image"
            style={{ marginRight: '10px' }}
          />
          <FormControlLabel
            value="Text"
            control={<Radio />}
            label="Text"
            style={{ marginRight: '10px' }}
          />
          <FormControlLabel
            value="ImageAndText"
            control={<Radio />}
            label="Image & Text"
            style={{ marginRight: '10px' }}
          />
          <FormControlLabel
            value="Audio"
            control={<Radio />}
            label="Audio"
            style={{ marginRight: '10px' }}
          />
        </RadioGroup>
      </FormControl>

      {showResponsePreview && question?.categoryType === 'Image' ? (
        <PictureAssignment disabled={true} containerClassName="assignment-ebook" />
      ) : showResponsePreview && question?.categoryType === 'Text' ? (
        <Row gutter={[0, 24]} className="text-box-container">
          <Col span={24}>
            <TextEditor
              handleChange={() => {}}
              value={''}
              autoFocus={false}
              disabled={true}
              containerClassName="question-ebook-text-field"
            />
          </Col>
        </Row>
      ) : showResponsePreview && question?.categoryType === 'ImageAndText' ? (
        <>
          <PictureAssignment disabled={true} containerClassName="assignment-ebook" />
          <Row className="text-box-container" gutter={[0, 24]}>
            <Col span={24}>
              <TextEditor
                handleChange={() => {}}
                value={''}
                autoFocus={false}
                disabled={true}
                containerClassName="question-ebook-text-field"
              />
            </Col>
          </Row>
        </>
      ) : showResponsePreview && question?.categoryType === 'Audio' ? (
        <AudioRecorder
          maxTime={question.duration || 60}
          handleAudio={() => {}}
          index={index}
          currentSubmission={{}}
          refresh={() => {}}
          isPreview
        />
      ) : null}
    </div>
  );
};
export const ImageAudioAssignmentType = (props) => {
  const { question = {}, index } = props?.states || {};
  const { onChangeQuestionData } = props?.funcObj || {};
  const { handlePicture } = props || {};

  return (
    <div className="category-type-radio-type">
      <Detail>Answer Type</Detail>
      <FormControl>
        <RadioGroup
          row
          onChange={(e) => {
            if (onChangeQuestionData) {
              onChangeQuestionData(e.target.value, 'categoryType', index);
            }
          }}
          aria-labelledby="category-type-radio-buttons-group-label"
          name="category-type-radio-buttons-group-label"
          style={{ gap: '20px' }}
          defaultValue={'Image'}
          value={question.categoryType || 'Image'}
        >
          <FormControlLabel
            value="Image"
            control={<Radio />}
            label="Image"
            style={{ marginRight: '10px' }}
          />
        </RadioGroup>
      </FormControl>

      <PictureAssignment
        disabled={true}
        containerClassName="assignment-ebook"
        handlePicture={handlePicture || onChangeQuestionData}
      />
    </div>
  );
};

export default PictureAssignmentType;

const AssignmentDescription = styled.span`
  color: ${COLOR.black300};
  display: block;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
`;

const Detail = styled(AssignmentDescription)`
  color: ${COLOR.black600};
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: ${(p) => (p.index == 0 ? 'opx' : '24px')};
`;
